export default "__VITE_ASSET__65a791c1__"